// extracted by mini-css-extract-plugin
export default {"root":"PcSpecTabs_root__SMn7o","tabs":"PcSpecTabs_tabs__sSFBH"};